import {
    QUIZ_MUTATOR_ADD_ANSWER,
    QUIZ_MUTATOR_LOAD_SELECTED,
    QUIZ_MUTATOR_REMOVE_ANSWER,
    QUIZ_MUTATOR_RESET,
    QUIZ_MUTATOR_SET_ANSWER,
    QUIZ_MUTATOR_SET_AUTO_TRANSLATIONS,
    QUIZ_MUTATOR_SET_BUILDING,
    QUIZ_MUTATOR_SET_CORRECT,
    QUIZ_MUTATOR_SET_QUESTION,
    QUIZ_MUTATOR_SET_SHOW_VALIDATION,
    QUIZ_MUTATOR_SET_TITLE,
    QUIZ_MUTATOR_SET_TRANSLATION,
    QUIZ_MUTATOR_TOGGLE_AUTO_TRANSLATIONS,
    QUIZ_MUTATOR_SET_PROPERTY,
    QUIZ_MUTATOR_SET_CLIENT
} from '../actionTypes'

const defaultTranslatedText = [{ language: 'ENGLISH', text: '' }]

const defaultAnswerState = {
    correct: false,
    text: defaultTranslatedText,
    valid: false,
}

const defaultState = {
    answers: {
        valid: false,
        list: [defaultAnswerState, defaultAnswerState],
    },
    autoTranslations: [],
    question: {
        text: defaultTranslatedText,
        valid: false,
    },
    selectedLanguage: 'ENGLISH',
    showAutoTranslations: false,
    showValidation: false,
    title: {
        text: defaultTranslatedText,
        valid: false,
    },
}

const quizMutatorReducer = (state = defaultState, action) => {
    switch (action.type) {
        case QUIZ_MUTATOR_ADD_ANSWER:
            return {
                ...state,
                answers: {
                    ...state.answers,
                    list: [...state.answers.list, defaultAnswerState],
                },
            }

        case QUIZ_MUTATOR_LOAD_SELECTED:
            const d1 = action.selectedQuiz.d1.split('#')
            return {
                ...state,
                answers: {
                    list: action.selectedQuiz.answers.map((answer) => {
                        return {
                            correct: answer.correct,
                            text: answer.text,
                            valid: true,
                        }
                    }),
                    valid: true,
                },
                buildingPk: d1[3],
                clientPk: d1[0],
                propertyPk: d1[2],
                buildingName: action.selectedQuiz.meta.buildingName,
                clientName: action.selectedQuiz.meta.clientName,
                propertyName: action.selectedQuiz.meta.propertyName,
                question: {
                    text: action.selectedQuiz.question,
                    valid: true,
                },
                title: {
                    text: action.selectedQuiz.meta.title,
                    valid: true,
                },
            }

        case QUIZ_MUTATOR_REMOVE_ANSWER:
            return {
                ...state,
                answers: {
                    ...state.answers,
                    list: state.answers.list
                        .slice(0, action.index)
                        .concat(state.answers.list.slice(action.index + 1)),
                },
            }

        case QUIZ_MUTATOR_RESET:
            return defaultState

        case QUIZ_MUTATOR_SET_ANSWER:
            const newAnswerList = state.answers.list.map((answer, answerIndex) => {
                if (action.index === answerIndex) {
                    return {
                        ...answer,
                        text: [
                            {
                                language: 'ENGLISH',
                                text: action.val,
                            },
                        ],
                        valid: action.val.length > 0,
                    }
                } else {
                    return answer
                }
            })

            return {
                ...state,
                answers: {
                    list: [...newAnswerList],
                    valid:
                        newAnswerList.length > 1 &&
                        newAnswerList.some((ans) => ans.correct) &&
                        newAnswerList.every((ans) => ans.valid),
                },
            }

        case QUIZ_MUTATOR_SET_AUTO_TRANSLATIONS:
            return {
                ...state,
                autoTranslations: action.translations,
            }

        case QUIZ_MUTATOR_SET_CORRECT:
            const newAnswerList2 = state.answers.list.map((answer, index) => {
                if (action.index === index) {
                    return {
                        ...answer,
                        correct: !answer.correct,
                    }
                } else {
                    return {
                        ...answer,
                        correct: false,
                    }
                }
            })

            return {
                ...state,
                answers: {
                    ...state.answers,
                    list: newAnswerList2,
                    valid: newAnswerList2.some((ans) => ans.correct),
                },
            }

        case QUIZ_MUTATOR_SET_QUESTION:
            return {
                ...state,
                question: {
                    text: action.question,
                    valid: action.question.length > 0,
                },
            }

        case QUIZ_MUTATOR_SET_TITLE:
            return {
                ...state,
                title: {
                    text: action.title,
                    valid: action.title.length > 0,
                },
            }

        case QUIZ_MUTATOR_SET_TRANSLATION:
            return {
                ...state,
                selectedLanguage: action.language,
            }

        case QUIZ_MUTATOR_SET_SHOW_VALIDATION:
            return {
                ...state,
                showValidation: action.val,
            }

        case QUIZ_MUTATOR_TOGGLE_AUTO_TRANSLATIONS:
            return {
                ...state,
                autoTranslations: [],
                showAutoTranslations: !state.showAutoTranslations,
            }
       
            case QUIZ_MUTATOR_SET_BUILDING:
                return {
                    ...state,
                    buildingPk: action.buildingPk,
                    buildingName: action.buildingName
                }
    
            case QUIZ_MUTATOR_SET_CLIENT:
                return {
                    ...state,
                    clientPk: action.clientPk,
                    clientName: action.clientName
                }
    
            case QUIZ_MUTATOR_SET_PROPERTY:
                return {
                    ...state,
                    propertyPk: action.propertyPk,
                    propertyName: action.propertyName
                }
        default:
            return state
    }
}

export default quizMutatorReducer
